import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const userDoc = await getDoc(doc(db, 'users', cred.user.uid));
      if (!userDoc.exists() || userDoc.data().role !== 'superadmin') {
        setError('Access denied. Platform admin accounts only.');
        await auth.signOut();
      }
    } catch {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.container}>
      <div style={s.card}>
        <img src="onshifts.png" alt="OnShifts" style={{ height: 60, objectFit: 'contain', marginBottom: 8 }} />
        <p style={s.subtitle}>Platform Admin</p>
        {error && <div style={s.error}>{error}</div>}
        <form onSubmit={handleLogin}>
          <input style={s.input} type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={s.input} type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={s.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0f0f0f' },
  card: { backgroundColor: '#1e1e1e', borderRadius: 16, padding: 40, width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.4)' },
  subtitle: { color: '#999', fontSize: 16, marginBottom: 32, marginTop: 0 },
  error: { backgroundColor: '#2d1414', color: '#f87171', padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 14 },
  input: { width: '100%', backgroundColor: '#2a2a2a', border: 'none', borderRadius: 10, padding: '14px 16px', color: '#fff', fontSize: 16, marginBottom: 12, boxSizing: 'border-box', outline: 'none' },
  button: { width: '100%', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: 10, padding: '14px 16px', fontSize: 16, fontWeight: 'bold', cursor: 'pointer', marginTop: 8 },
};
